module.exports = __webpack_public_path__ + "media/lacCalme.817fb84a.mp4";